import { useContext, useEffect } from "react";
import { useLocation } from "react-router-dom";
import { SessionContext } from "../../context/SessionContext";
import { prewarmGuide } from "../../api/ltv/prewarmGuide";

export default function GuidePrewarm() {
  const { pathname } = useLocation();
  const { profile, activePlayerCount } = useContext(SessionContext) || {};
  const profileId = profile?.id;
  useEffect(() => {
    if (
      !profileId ||
      activePlayerCount > 0 ||
      !pathname.startsWith("/dashboard/home")
    )
      return;
    let cancelled = false;
    let idle;
    // Give the visible catalogue and its images priority over speculative data.
    const timer = setTimeout(() => {
      const start = () => prewarmGuide({ cancelled: () => cancelled });
      if (window.requestIdleCallback)
        idle = window.requestIdleCallback(start, { timeout: 3000 });
      else start();
    }, 8000);
    return () => {
      cancelled = true;
      clearTimeout(timer);
      if (idle !== undefined && window.cancelIdleCallback)
        window.cancelIdleCallback(idle);
    };
  }, [pathname, profileId, activePlayerCount]);
  return null;
}
